import {Injectable} from 'ng-metadata/core';
import {Inject} from "ng-metadata/src/core/di/decorators";
import {SharedSessionStorage} from "../../../infra/sharedSessionStorage.service";
import {PersonalizeResultsButtonService} from '../personalizationButton/personalizeResultsButton.service';
import {JwtUtilService} from '../../../security/jwtUtil.service';


@Injectable()
export class PersonalizationDialogService {

    constructor(private sharedSessionStorage: SharedSessionStorage,
                private personalizeResultsButtonService: PersonalizeResultsButtonService,
                private jwtUtilService: JwtUtilService) {}



    public resetPersonalization() {
        this.sharedSessionStorage.removeItem('personalization');
        this.sharedSessionStorage.removeItem('enable_personalization');
        this.sharedSessionStorage.removeItem('recentness');
        this.personalizeResultsButtonService.enable = false;
        this.personalizeResultsButtonService.recentness = false;
        this.personalizeResultsButtonService.editPressed= false;
    }

    public isSignedIn(){
        return this.jwtUtilService.isSignedIn();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/personalization/personalizationDialog/personalizationDialog.service.ts